import Footer from '../../common/components/List/Footer/index.js'
import {
  setLimit,
  setOffset,
  isLoadingSelector,
  transferListQuerySelector,
  countSelector,
} from './transferListFunctions.js'
import {useSelector} from '../../store.js'

export default function TransferListFooter() {
  const params = useSelector(transferListQuerySelector)
  const isLoading = useSelector(isLoadingSelector)
  const count = useSelector(countSelector)

  return (
    <Footer
      isLoading={isLoading}
      limit={params.limit}
      offset={params.offset}
      count={count}
      setLimit={setLimit}
      setOffset={setOffset}
      preventResetOffset
    />
  )
}
